import { useState } from 'react';
import PanelHeader from './components/PanelHeader';
import PanelBody from './PanelBody';
import CampaignsSection from './CampaignsSection';
import CatalogSection from './CatalogSection';

/**
 * Vista de una marca: header (siempre visible) con el segmentado + la sección
 * activa (Resumen = dashboard por vertical, o Campañas y anuncios). Compartida
 * por el panel admin (con back + selector de marca) y el del cliente. El fetch
 * lo hace el caller y pasa los resultados en `panel` / `campaigns`.
 */
export default function BrandView({
  brand,
  panel,
  campaigns,
  catalog,
  dateControls,
  onBack,
  brandSwitcher,
  previewFetcher,
}) {
  const [section, setSection] = useState('summary');
  // Catálogo solo existe para ecom; si se quedó seleccionado al cambiar de
  // marca (admin), cae a Resumen.
  const active = section === 'catalog' && brand?.vertical !== 'ecommerce' ? 'summary' : section;

  return (
    <div className="space-y-6">
      <PanelHeader
        brand={brand}
        updatedAt={campaigns?.data?.updated_at}
        dateControls={dateControls}
        section={active}
        onSectionChange={setSection}
        onBack={onBack}
        brandSwitcher={brandSwitcher}
      />

      {active === 'summary' &&
        (panel.isLoading && !panel.data ? (
          <p className="py-12 text-center text-sm text-gray-500">Cargando panel…</p>
        ) : panel.isError || !panel.data ? (
          <p className="py-12 text-center text-sm text-red-600">
            No se pudo cargar el panel. Probá de nuevo en unos segundos.
          </p>
        ) : (
          <PanelBody data={panel.data} previousSummary={panel.previousSummary} />
        ))}

      {active === 'campaigns' && (
        <CampaignsSection
          data={campaigns?.data}
          isLoading={campaigns?.isLoading}
          isError={campaigns?.isError}
          vertical={brand?.vertical}
          previewFetcher={previewFetcher}
        />
      )}

      {active === 'catalog' && (
        <CatalogSection
          data={catalog?.data}
          isLoading={catalog?.isLoading}
          isError={catalog?.isError}
        />
      )}
    </div>
  );
}
